export const PATH = {
  HOME: '/',
  WELCOME_PAGE: '/welcome',
  LOG_IN: '/login',
  SIGN_OUT: '/logout',
  SIGN_UP: '/signup',
  BOARD: '/board/',
  COLUMNS: '/columns/',
  PROFILE: '/profile/',
};

export const MAIN_PAGE_TITLE = 'Main Page Title';
export const WELCOME_PAGE_TITLE = 'Welcome to Lemasello';
export const PAGE_404_TITLE = 'Error 404, this page can not be found...';

export const LOGIN_FORM_PAGE_TITLE = 'Login Form';
export const SIGNUP_FORM_PAGE_TITLE = 'Signup Form';

export const STANDARD_PADDING = 18;
export const PAGE_404_MESSAGE = 'Something wrong, you can back to ';
export const PAGE_404_LINK_TO = 'main page';
